<template src='./ArrobaMedellinVerticalCardNetworking.html'></template>

<script>
export default {
  props: {
    img: { type: String },
    imgDescription: { type: String, default: "Imagen de sala" },
    title: { type: String },
    subtitle: { type: String },
    subtitle2: { type: String },
    body: { type: [String, Object], required: false },
    progress: { type: [Number, String]},
    typeCard: { type: Object },
    url: { type: String },
    aforo: { type: Number , required: false},
    person: { type: Number, required: false},
    room: { type: Object },
    isModerator: { type: Boolean, default: false },
    // Moderador de la sala o administrador: puede editarla y descargar el reporte
    canManage: { type: Boolean, default: false },
    moderatorName: { type: String, required: false }
  },
  name: 'arroba-medellin-vertical-card-networking',
  methods: {
    pushButton() {
      this.$emit('verticalCardClickButton', { typeButton: this.buttonText, url: this.url, room: this.room})
    },
  },
    computed: {
      // Siempre se puede intentar entrar: `person` es solo informativo y puede
      // quedar desactualizado. El cupo se valida en vivo al pulsar (Networking.vue)
      // y otra vez en gestor-api al emitir el token de LiveKit.
      buttonText() {
        return 'Ingresar'
      },
      disableButton() {
        return false
      },
      imgUrl() {
        return this.img ? this.img : 'https://storage.googleapis.com/arrobamedellin.appspot.com/Img_default.png';
      }
    }
}
</script>

<style lang="scss" scoped src="./ArrobaMedellinVerticalCardNetworking.scss"></style>
